var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"divider"},[_c('div',{staticClass:"divider__line"}),_c('div',{staticClass:"divider__content"},[_vm._t("default")],2),_c('div',{staticClass:"divider__line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }